<section id="secao-sobre">
  <div class="container">
    <div class="image">
      <img src="assets/imagens/cultura-colaborativa.png" />
    </div>
    <div class="title mt-4">
      <h1 class="text-center text-white display-4">Sobre a Fundação Educere</h1>
    </div>
  </div>
</section>
